// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"304c4991","703":"066f9c87","787":"a316a84a"}[chunkId] + ".chunk.js";
};